<div class="libraries-selected-documents-menu-container">
  <div class="buttons">
    <button (click)="copySelectedDocuments()" mat-stroked-button>
      Clone
      <mat-icon matTooltip="Copy selected documents"> content_copy </mat-icon>
    </button>
    <button mat-stroked-button (click)="downloadSelectedDocuments()" [disabled]="selectedDocuments.length !== 1">
      Open Document
      <mat-icon matTooltip="Download selected documents"> download </mat-icon>
    </button>
  </div>
</div>
